<div  class="animated fadeIn">
    <div class="row">
      <div class="col-lg-12">
        <div class="card text-black bg-white mb-3" >        
          <div class="card-body">
            <h5 class="card-title">Videos Count</h5>
           <div class="text-black display-4 text-end">          
            <p>{{videoCount}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="isLoad" class="animated fadeIn">
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header">
          <span><i class="icon-user-following"></i>Videos</span>
        </div>
        <div class="card-body">
          <div
            class="table-responsive{-sm|-md|-lg|-xl} table-responsive-sm table-responsive-md table-responsive-lg table-responsive-xl">
            <table class="table table-striped table-hover">
              <thead class="table-primary">
                <tr>
                  <th>User Name</th>
                  <th>Email</th>
                  <th>Videos</th>                  
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colspan="6" class="text-center mt-3">
                    <div class="sk-wandering-cubes">
                      <div class="sk-cube sk-cube1"></div>
                      <div class="sk-cube sk-cube2"></div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="animated fadeIn" *ngIf="!isLoad">
<div class="row">
  <div class="col-lg-12">
    <div class="card mb-3">
      <div class="card-header">
        <span><i class="fa fa-youtube-play"></i> Videos</span>
       
      </div>
      <div class="card-body">
        <div class="row mb-3"> 
        </div>  
        <div
        class="table-responsive{-sm|-md|-lg|-xl} table-responsive-sm table-responsive-md table-responsive-lg table-responsive-xl">
        <table class="table table-striped table-hover">
          <thead class="table-primary">
            <tr>
              <th>User Name</th>
              <th>Email</th>
              <th>Videos</th>              
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of allUsersVideosCount">
             <th>{{data.firstName}} {{data.lastName}}</th>
            <th>{{data.email}}</th>
           <th>{{data.totalVideoCount}}</th>
            </tr>
            <tr *ngIf="">
              <td class="text-center mt-3" colspan="6">No data found</td>
            </tr>
          </tbody>
        </table>
      </div>  
    </div>
  </div>
</div>
</div>
</div>
    <!-- <div class="animated fadeIn" *ngIf="!isLoad">
      <div class="row">
        <div class="col-lg-12">
          <div class="card mb-3">
            <div class="card-header">
              <span><i class="fa fa-user-times"></i> InActive Users</span>
             
            </div>
            <div class="card-body">
             
            
              <div
                class="table-responsive{-sm|-md|-lg|-xl} table-responsive-sm table-responsive-md table-responsive-lg table-responsive-xl">
                <table class="table table-striped table-hover">
                  <thead class="table-primary">
                    <tr>
                      <th>UserName</th>
                      <th>Email</th>
                      <th>Created Date</th>
                      <th>Modified Date<th>                    
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                   
                  </tbody>
                </table>
              </div>
                        
            </div>
          </div>
        </div>
      </div>
    </div>  -->

